import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { backgroundColor } from '@/constants/constants';
import { ColorScheme } from '@/types/features';

type ThemeColorState = {
    scheme: ColorScheme | null;
    hasHydrated: boolean;
    setScheme: (scheme: ColorScheme) => void;
    setHasHydrated: (hydrated: boolean) => void;
};

export const useThemeColorStore = create<ThemeColorState>()(
    persist(
        (set, get) => ({
            scheme: null,
            hasHydrated: false,
            setScheme: (scheme) => set({ scheme }),
            setHasHydrated: (hydrated) => set({ hasHydrated: hydrated }),
        }),
        {
            name: 'KEY-THEME-COLOR',
            storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
            onRehydrateStorage: () => (state, error) => {
                if (error) {
                    return;
                }
                if (state) {
                    if (!state.scheme) {
                        state.setScheme(backgroundColor[2]);
                    }
                    state.setHasHydrated(true);
                }
            },
        },
    ),
);
